import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { getCall, postCall } from "../../../api/post";
import { connect } from "react-redux";
import { getImageUrl, getPlaceHolderImage } from "../../../services";
import { isInquiryOrCart } from "../../../actions";
import {
  getValueFromLanguageObject,
  getCurrencySymbol,
  loadUserDetailsFromLocalStorage,
  getOpenStoreIdApp,
  formatPrice,
} from "../../../store";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
} from "../../../utils/utils";
import Lightbox from "react-image-lightbox";
import { addToCompare } from "../../../actions";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import Modal from "@material-ui/core/Modal";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

class ProductItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stock:
        props.product.availablequantity > 0
          ? getValueFromLanguageObject("str_instock")
            ? getValueFromLanguageObject("str_instock")
            : "InStock"
          : getValueFromLanguageObject("str_out_of_stock")
          ? getValueFromLanguageObject("str_out_of_stock")
          : "Out of Stock !",
      quantity:
        props.product.minimumorderquantity >= 1
          ? props.product.minimumorderquantity
          : 1,
      image: "",
      currentProduct: {},
      category: {},
      pincode: "",
      showErrorMessageModal: false,
      errorMessage: "",
      isFullScreenImage: false,
      fullScreenImagePath: "",
      showAddToCompareMessageModal: false,
      addToCompareMessage: "",
      addToWishlistMessage: "",
      showAddToWishlistMessageModal: false,
      showImagesModal: false,
      modalImageIndex: 0, // <-- add this for image navigation
    };
  }

  componentDidMount() {
    const { masterDetailsObj } = this.props;
    this.props.isInquiryOrCart(masterDetailsObj);
  }

  onClickHandle(img) {
    this.setState({ image: img });
  }

  minusQty = () => {
    if (this.state.quantity > this.props.product.minimumorderquantity) {
      this.setState({
        stock: getValueFromLanguageObject("str_instock")
          ? getValueFromLanguageObject("str_instock")
          : "InStock",
      });
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  plusQty = () => {
    if (this.props.product.availablequantity > this.state.quantity) {
      this.setState({ quantity: this.state.quantity + 1 });
    } else {
      this.setState({
        stock: getValueFromLanguageObject("str_out_of_stock")
          ? getValueFromLanguageObject("str_out_of_stock")
          : "Out of Stock !",
      });
    }
  };

  changeQty = (e) => {
    const { isInquiry, product } = this.props;
    if (!isInquiry && product.availablequantity === 0) {
      return;
    }

    if (e.target.value === "" || e.target.value === "-") {
      this.setState({ quantity: "" });
      return;
    }
    if (e.target.value < 1) {
      return;
    }
    try {
      this.setState({ quantity: parseInt(e.target.value) });
    } catch (error) {
      this.setState({ quantity: "" });
    }
  };

  addToCartBase = () => {
    const { pincode } = this.state;
    const { product, onAddToCartClicked, isInquiry } = this.props;
    onAddToCartClicked(product, this.state.quantity, isInquiry, pincode);
  };

  getCartListCounter = async () => {
    let cartCounter = 0;
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;
    const counterUrl = "commoncounters?filter[where][userId]=" + userId;
    const commonCounter = await getCall(counterUrl, []).then();
    if (commonCounter.error) {
      clearLocalStorageReload({ response: commonCounter });
      this.loadErrorMessageAnimation(commonCounter.error.message);
    } else {
      if (commonCounter.length > 0) {
        cartCounter = commonCounter[0].cart;
      }
    }
    return cartCounter;
  };

  pincodeHandleSubmit = (event) => {
    this.setState({ pincode: event.target.value });
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadAddToCompareMessageAnimation = (message) => {
    this.setState({
      addToCompareMessage: message,
      showAddToCompareMessageModal: true,
    });
  };

  loadAddToWishlistMessageAnimation = (message) => {
    this.setState({
      addToWishlistMessage: message,
      showAddToWishlistMessageModal: true,
    });
  };

  handleOpenImagesModal = () => {
    this.setState({ showImagesModal: true, modalImageIndex: 0 });
  };

  handleCloseImagesModal = () => {
    this.setState({ showImagesModal: false, modalImageIndex: 0 });
  };

  handlePrevImage = (total) => {
    this.setState((prevState) => ({
      modalImageIndex:
        prevState.modalImageIndex === 0
          ? total - 1
          : prevState.modalImageIndex - 1,
    }));
  };

  handleNextImage = (total) => {
    this.setState((prevState) => ({
      modalImageIndex:
        prevState.modalImageIndex === total - 1
          ? 0
          : prevState.modalImageIndex + 1,
    }));
  };

  highlightMatch = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.split(regex).map((part, i) =>
      regex.test(part) ? (
        <span
          key={i}
          style={{ background: "#fff3cd", color: "#d48806", fontWeight: 700 }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // addToCompareAPI = async (product) => {
  //   if (!product || !product.id) {
  //     console.error("Invalid product object passed to comparison");
  //     this.loadErrorMessageAnimation("Invalid product data.");
  //     return;
  //   }

  //   const body = {
  //     productId: product.id,
  //   };

  //   try {
  //     const response = await postCall("v2/product-comparisons", body);

  //     if (response && response.success) {
  //       console.log("Product added to comparison:", response.message);

  //       // Show a success message
  //       const successMessage =
  //         getValueFromLanguageObject("str_add_to_compare_successfully") ||
  //         response.message || "Product added to compare successfully";
  //       this.loadAddToCompareMessageAnimation(successMessage);
  //     } else if (response.detail && response.detail.responseMessageCode === "COMPARISON_DUPLICATE") {
  //       // Handle duplicate comparison scenario
  //       console.warn("Product already in comparison list:", response.detail.responseData.message);

  //       // Show the error animation with the duplicate message
  //       this.loadErrorMessageAnimation(response.detail.responseData.message || "Product already in comparison list.", true);
  //     } else {
  //       console.error("Failed to add product to comparison:", response);
  //       this.loadErrorMessageAnimation(
  //         response.message || "Failed to add product to comparison."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error adding product to comparison:", error);
  //     this.loadErrorMessageAnimation(
  //       "An error occurred while adding the product to comparison."
  //     );
  //   }
  // };

  addToCompare = () => {
    const { product, addToCompareAPI } = this.props;

    if (addToCompareAPI) {
      addToCompareAPI(product); // Call the method passed as a prop
    } else {
      console.error("addToCompareAPI method is not provided as a prop.");
    }
  };

  addToWishlist = () => {
    const { product, addToWishlistAPI } = this.props;

    if (addToWishlistAPI) {
      addToWishlistAPI(product); // Call the method passed as a prop
    } else {
      console.error("addToWishlistAPI method is not provided as a prop.");
    }
  };

  render() {
    const {
      product,
      symbol,
      onAddToCartClicked,
      onAddToWishlistClicked,
      isInquiry,
      showErrorMessageModal,
      errorMessage,
      masterDetailsObj,
      handleClickOfQuickView,
      addToCompare,
    } = this.props;

    const {
      isFullScreenImage,
      fullScreenImagePath,
      showAddToCompareMessageModal,
      addToCompareMessage,
      showAddToWishlistMessageModal,
      addToWishlistMessage,
      showImagesModal,
      modalImageIndex,
    } = this.state;

    const strOutOfStock = getValueFromLanguageObject("str_out_of_stock")
      ? getValueFromLanguageObject("str_out_of_stock")
      : "Out of Stock";

    const strThereAre = getValueFromLanguageObject("str_there_are")
      ? getValueFromLanguageObject("str_there_are")
      : "There are";

    const strUnitsOfItemAlreadyInTheCart = getValueFromLanguageObject(
      "str_units_of_item_already_in_the_cart"
    )
      ? getValueFromLanguageObject("str_units_of_item_already_in_the_cart")
      : "units of item already in the cart";

    const strAddToWishList =
      getValueFromLanguageObject("str_add_to_wishlist") || "Add to wishlist";

    const productImages =
      product.productmedia && product.productmedia.length > 0
        ? product.productmedia.map((media) =>
            getImageUrl(media.productname, masterDetailsObj)
          )
        : [getPlaceHolderImage()];

    // Modern card design
    // Accept cardWidth from props, fallback to 290 if not provided
    const cardWidth = this.props.cardWidth || 290;
    const isListView =
      this.props.colClass === "col-lg-12" || this.props.isListView;
    if (isListView) {
      return (
        <>
          <div className="card d-flex align-items-center p-4 mb-3 w-100 flex-row product-box">
            {/* ================= LEFT : IMAGE ================= */}
            <div
              className="p-img position-relative"
              style={{ flex: "0 0 180px", marginRight: "32px" }}
            >
              <img
                src={
                  product.productmedia.length > 0
                    ? getImageUrl(
                        product.productmedia[0].productname,
                        masterDetailsObj
                      )
                    : getPlaceHolderImage()
                }
                alt={product.name}
                style={{
                  width: "180px",
                  height: "180px",
                  objectFit: "contain",
                  borderRadius: "16px",
                  background: "#f8fafc",
                }}
              />

              {/* ❤️ Wishlist Icon (Top Right on Image) */}
              <button
                title={strAddToWishList}
                onClick={() =>
                  this.props.onAddToWishlistClicked(this.props.product)
                }
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  background: "#fff",
                  border: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <i
                  className={
                    product.iswhishlist ? "fa fa-heart" : "fa fa-heart-o"
                  }
                  style={{
                    color: product.iswhishlist ? "red" : "#999",
                    fontSize: "16px",
                  }}
                />
              </button>
            </div>

            {/* ================= RIGHT : DETAILS ================= */}
            <div className="d-flex flex-column justify-content-between flex-grow-1">
              <div>
                <h4
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginBottom: "10px",
                    color: "#222",
                  }}
                >
                  {this.highlightMatch(product.name, this.props.searchValue)}
                </h4>

                <div
                  style={{
                    fontSize: "14px",
                    color: "#888",
                    marginBottom: "8px",
                  }}
                >
                  {product.subcategory && (
                    <span style={{ marginRight: "12px" }}>
                      Subcategory: {product.subcategory.name}
                    </span>
                  )}
                  {product.category && (
                    <span>Category: {product.category.name}</span>
                  )}
                </div>

                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#1252C9",
                    marginBottom: "8px",
                  }}
                >
                  {formatPrice(product.price)}
                </div>
              </div>

              {/* ================= ACTIONS ================= */}
              <div
                className="d-flex align-items-center mt-3"
                style={{ gap: "12px" }}
              >
                {/* 🛒 Add to Cart Button */}
                <button
                  onClick={() => {
                    if (!isInquiry && product.availablequantity === 0) return;
                    onAddToCartClicked(product, this.state.quantity, isInquiry);
                  }}
                  className="btn btn-primary d-flex align-items-center"
                  style={{
                    borderRadius: "20px", // smaller rounded button
                    padding: "6px 12px", // smaller padding
                    fontWeight: 600,
                    gap: "4px", // smaller gap between icon & text
                    fontSize: "13px", // smaller text
                  }}
                >
                  <i
                    className="fa fa-shopping-cart text-white"
                    style={{ fontSize: "14px" }}
                  ></i>
                  {isInquiry ? "Add to Inquiry" : "Add to Cart"}
                </button>

                {/* 🔁 Compare Icon */}
                <button
                  title={
                    getValueFromLanguageObject("str_add_to_compare") ||
                    "Add to Compare"
                  }
                  onClick={() =>
                    !product.iscomparison &&
                    this.props.addToCompare(this.props.product, (msg) =>
                      this.loadAddToCompareMessageAnimation(msg)
                    )
                  }
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "42px",
                    height: "42px",
                    background: product.iscomparison ? "#FFA726" : "#fff",
                    border: "none",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    cursor: product.iscomparison ? "default" : "pointer",
                    pointerEvents: product.iscomparison ? "none" : "auto",
                    opacity: product.iscomparison ? 0.8 : 1,
                  }}
                >
                  <i
                    className={
                      product.iscomparison ? "fa fa-exchange" : "fa fa-exchange"
                    } // filled vs outline
                    style={{
                      color: product.iscomparison ? "white" : "#999",
                      // backgroundColor: product.iscomparison ? "#FFA726" : "transparent",
                      fontSize: "18px",
                    }}
                  />
                </button>
              </div>
            </div>
          </div>

          {/* ================= MODALS ================= */}
          {showErrorMessageModal && (
            <ErrorMessageAnimationModal
              show={showErrorMessageModal}
              message={errorMessage}
              onClose={() => this.setState({ showErrorMessageModal: false })}
            />
          )}

          {showAddToCompareMessageModal && (
            <SuccessMessageAnimationModal
              show={showAddToCompareMessageModal}
              message={addToCompareMessage}
              onClose={() =>
                this.setState({ showAddToCompareMessageModal: false })
              }
            />
          )}

          {showAddToWishlistMessageModal && (
            <SuccessMessageAnimationModal
              show={showAddToWishlistMessageModal}
              message={addToWishlistMessage}
              onClose={() =>
                this.setState({ showAddToWishlistMessageModal: false })
              }
            />
          )}
        </>
      );
    }

    // Grid view layout (existing code)
    return (
      <>
        <div className="card p-3 mb-3 product-box">
          {/* ================= IMAGE ================= */}
          <div
            className="p-img position-relative mb-3 bg-light rounded overflow-hidden"
            style={{
              paddingTop: "100%",
              background: "#f8fafc",
            }}
          >
            <Link
              to={`/singleproduct/${product.id}`}
              className="d-block position-absolute w-100 h-100"
              style={{ top: 0, left: 0 }}
            >
              <img
                src={
                  product.productmedia.length > 0
                    ? getImageUrl(
                        product.productmedia[0].productname,
                        masterDetailsObj
                      )
                    : getPlaceHolderImage()
                }
                alt={product.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = getPlaceHolderImage();
                }}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            </Link>

            {/* ❤️ Wishlist icon on image */}
            <button
              title={strAddToWishList}
              onClick={() =>
                !product.iswhishlist &&
                this.props.onAddToWishlistClicked(this.props.product)
              }
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "#fff",
                border: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: product.iswhishlist ? "default" : "pointer",
                pointerEvents: product.iswhishlist ? "none" : "auto",
              }}
            >
              <i
                className={
                  product.iswhishlist
                    ? "fa fa-heart" // filled heart
                    : "fa fa-heart-o" // outline heart
                }
                style={{
                  color: product.iswhishlist ? "red" : "#999",
                  fontSize: "18px",
                }}
              />
            </button>
          </div>

          {/* ================= DETAILS ================= */}
          <div className="details w-100 flex-grow-1">
            <Link to={`/singleproduct/${product.id}`}>
              <h4 className="fw-bold">
                {this.highlightMatch(product.name, this.props.searchValue)}
              </h4>
            </Link>

            {product.subcategory && (
              <span style={{ color: "#888", fontSize: "13px" }}>
                Subcategory: {product.subcategory.name}
              </span>
            )}

            {product.category && (
              <div style={{ color: "#888", fontSize: "13px" }}>
                {product.category.parentId === null
                  ? "Category"
                  : "Subcategory"}
                : {product.category.name}
              </div>
            )}

            <div
              style={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#1252C9",
                marginTop: "6px",
              }}
            >
              {formatPrice(product.price)}
            </div>
          </div>

          {/* ================= ACTIONS ================= */}
          <div
            className="d-flex justify-content-center align-items-center mt-3"
            style={{ gap: "10px" }}
          >
            {/* 🛒 Add to Cart Button */}
            {/* 🛒 Add to Cart Button */}
            <button
              onClick={() => {
                if (!isInquiry && product.availablequantity === 0) return;
                onAddToCartClicked(product, this.state.quantity, isInquiry);
              }}
              className="btn btn-primary d-flex align-items-center"
              style={{
                borderRadius: "20px", // slightly smaller
                padding: "6px 10px", // smaller padding
                fontWeight: 600,
                gap: "4px", // smaller gap between icon & text
                fontSize: "13px", // smaller text
              }}
            >
              <i
                className="fa fa-shopping-cart text-white"
                style={{ fontSize: "14px" }}
              ></i>
              {isInquiry ? "Add to Inquiry" : "Add to Cart"}
            </button>

            {/* 🔁 Compare Icon */}
            <button
              title={
                getValueFromLanguageObject("str_add_to_compare") ||
                "Add to Compare"
              }
              onClick={() =>
                !product.iscomparison &&
                this.props.addToCompare(this.props.product, (msg) =>
                  this.loadAddToCompareMessageAnimation(msg)
                )
              }
              className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "42px",
                height: "42px",
                background: product.iscomparison ? "#FFA726" : "#fff",
                border: "none",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                cursor: product.iscomparison ? "default" : "pointer",
                pointerEvents: product.iscomparison ? "none" : "auto",
                opacity: product.iscomparison ? 0.8 : 1,
              }}
            >
              <i
                className={
                  product.iscomparison ? "fa fa-exchange" : "fa fa-exchange"
                } // filled vs outline
                style={{
                  color: product.iscomparison ? "white" : "#999",
                  // backgroundColor: product.iscomparison ? "#FFA726" : "transparent",
                  fontSize: "18px",
                }}
              />
            </button>
          </div>
        </div>

        {/* ================= MODALS ================= */}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => this.setState({ showErrorMessageModal: false })}
          />
        )}

        {showAddToCompareMessageModal && (
          <SuccessMessageAnimationModal
            show={showAddToCompareMessageModal}
            message={addToCompareMessage}
            onClose={() =>
              this.setState({ showAddToCompareMessageModal: false })
            }
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isInquiry: state.settings.isInquiry,
  symbol: getCurrencySymbol(),
});

export default connect(mapStateToProps, {
  isInquiryOrCart: isInquiryOrCart,
})(withRouter(ProductItem));
